import { useTranslation } from "react-i18next";

import { formatConditionValue } from "../conditionBadge";
import { getOperatorLabel } from "../operatorLabels";
import type { FormCondition } from "../schemas";

import type { SegmentField } from "@/features/segments/types";

type ConditionDetailsProps = {
  condition: FormCondition;
  fields: SegmentField[];
};

export function ConditionDetails({ condition, fields }: ConditionDetailsProps) {
  const { t } = useTranslation();
  const field = fields.find((candidate) => candidate.value === condition.field);
  const operator = condition.operator
    ? getOperatorLabel(t, condition.operator, condition.isInverted)
    : undefined;

  const rows = [
    { label: t("common.filter"), text: field?.label ?? condition.field },
    { label: t("common.searchType"), text: operator?.text },
    { label: t("common.value"), text: formatConditionValue(condition) },
  ].filter((row) => row.text);

  return (
    <div className="grid gap-2 text-sm">
      {condition.isInverted && !operator?.isNegated && (
        <p className="font-semibold">
          {t("admin.segments.builder.editor.excludedState")}
        </p>
      )}
      <dl className="grid gap-2">
        {rows.map((row) => (
          <div key={row.label} className="grid gap-0.5">
            <dt className="text-muted-foreground">{row.label}</dt>
            <dd className="[overflow-wrap:anywhere]">{row.text}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
